import {
  AdKind,
  VanAdConfig,
  VanAdDto,
  VanPlacementConfigModel,
} from '@marketplace-web/domain/ads-data'

export const transformVanAdPlacement = (
  config: VanAdConfig,
  ad?: VanAdDto,
): VanPlacementConfigModel => {
  const { page, placementId, fetchTime, platform, shape, countryCode, correlationId } = config

  if (!ad) {
    return {
      kind: AdKind.Van,
      id: null,
      creative: null,
      page,
      fetchTime,
      placementId,
      options: {
        isSticky: false,
      },
      shape,
      countryCode,
      platform,
      mediation: 'van',
      correlationId,
      priceReference: null,
    }
  }

  return {
    kind: AdKind.Van,
    id: ad.id,
    creative: {
      id: ad.creative.id,
      size: {
        height: ad.creative.size.height,
        width: ad.creative.size.width,
      },
      contentLink: ad.creative.content_link,
      clickThroughUrl: ad.creative.click_through_url,
    },
    page,
    fetchTime,
    placementId,
    options: {
      isSticky: false,
    },
    shape,
    countryCode,
    platform,
    mediation: 'van',
    correlationId,
    priceReference: ad.price_reference,
  }
}
